import { useNavigate } from "react-router-dom";
import { PledgeHistory } from "@project-mgmt/feature-ventures";
import { Container, Page } from "@project-mgmt/ui";
import { routes } from "../utils/routes";

export function MyPledgesPage() {
  const navigate = useNavigate();

  // Handle venture click from pledge history
  const handleVentureClick = (_ventureId: string) => {
    // Note: We need to get the workspaceId from the venture data
    // For now, we'll navigate to workspaces and let the user select
    // In a real implementation, the PledgeWithVenture type should include workspaceId
    navigate(routes.workspaces());
  };

  return (
    <Container size="xl">
      <Page>
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-textPrimary text-2xl font-bold">My Pledges</h1>
          <p className="text-textSecondary mt-1 text-sm">
            View all your pledges across ventures
          </p>
        </div>

        {/* Pledge History Component */}
        <PledgeHistory onVentureClick={handleVentureClick} />
      </Page>
    </Container>
  );
}
